import { AlgoliaQuery } from 'ha/services/algolia';
import { filterBuilder } from 'ha/modules/Algolia';
import getGeoBoundaryFilter from './getGeoBoundaryFilter';
import getFilterParams from './getFilterParams';
import {
  ReqParams,
  SearchParams,
  SearchOptions,
  CurrencyEuroRates,
} from './types';

const queryFilterBuilder = filterBuilder();

export default (
  reqParams: ReqParams,
  searchParams: SearchParams,
  currencyEuroRates: CurrencyEuroRates,
  searchOptions: SearchOptions = {},
): AlgoliaQuery => {
  const geoBoundaryFilter = getGeoBoundaryFilter(reqParams, searchParams);
  const filterParams = getFilterParams(reqParams, currencyEuroRates);
  const filters = queryFilterBuilder(filterParams);

  return {
    query: '',
    params: {
      distinct: true,
      insideBoundingBox: geoBoundaryFilter,
      attributesToHighlight: [],
      page: searchOptions.withoutData
        ? undefined
        : reqParams.offset / reqParams.limit,
      hitsPerPage: searchOptions.withoutData ? 0 : reqParams.limit,
      filters,
    },
  };
};
